import { createClient } from '@supabase/supabase-js';

import { Database } from '@/types/schema';

const supabaseUrl = process.env.REACT_APP_SB_URL as string;
const supabaseAnonKey = process.env.REACT_APP_SB_ANON_KEY as string;

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey);
